import React from "react"
import {Link} from "react-router-dom"
import {contextMenuItem} from "../functions"
import {MenuItem} from "./MenuItem"

export class GoogleFolderElement extends React.Component {

    render() {

        let {k, item, lang, iconsObject} = this.props

        const folder = item

        let icon = iconsObject['googleFolderImgFull']
        if (folder.type === 'google-folder' && folder['childrenCount'] === 0) {
            icon = iconsObject['googleFolderImgEmpty']
        }

        const menuItemData = {
            key: k,
            item: folder['type'],
            id: folder['id'],
            googleParent: folder['parentFID'] || 'root',
            name: folder['name'],
            thumb: icon,
            parent: item['parentFolder']
        }

        return (
            <div>
                <div className={"d-flex justify-content-center position-relative"}>
                    <Link
                        to={`/${lang.lang}/google-drive/open/${folder['id']}`}>
                        <div className={'hand-click'}>
                            <img id={"img-folder"} src={icon}
                                 className={"w-100 img-folder  rounded-4"}
                                 alt={"..."}/>
                        </div>
                    </Link>
                    {<MenuItem data={menuItemData}/>}
                    <div className={'hand-click'}
                         onClick={(e) => {
                             contextMenuItem(e, k)
                         }}>
                        <img id={"img-context-menu"} src={iconsObject['img_context_menu_google']}
                             className={"w-100 rounded-2"}
                             alt={"..."}/>
                    </div>
                </div>
                <p id={"name-file"}
                   className={"name-folder text-center mb-2 text-black p-0 fw-bold"}>{folder.name}
                </p>
            </div>
        )
    }
}